import { useTranslation } from 'react-i18next';
import styles from './or-line.module.scss';

export const OrLine = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.orLine}>
      <span>{t('common.or')}</span>
    </div>
  );
};
